import { useQuery } from "@tanstack/react-query";
import { searchQuestions } from "src/api/search";
import isPes from "src/helpers/isPes";
import newApi from "src/newApi";

import options from "./defaultOptions";

type LinkItem = { itemId: number; itemType: string };

export function useGetRelation(hash: string) {
	return useQuery({
		queryKey: [`relation-${hash}`],

		queryFn: async () => {
			const relation = await newApi.getLinkRelation(hash);
			const questions = relation.link.linksItems.filter(
				(item: LinkItem) => item.itemType === "question",
			);
			if (questions.length > 0) {
				if (!isPes()) {
					const questionsIds = questions.map(({ itemId }: LinkItem) => itemId);
					const result = await searchQuestions({ questions: questionsIds });
					relation.questions = result.items;
				}
			}

			return relation;
		},

		...options,
		enabled: !!hash,
	});
}
